// Evaluation payloads use zero cost for positive hours when wage data is absent.
export function availableLaborCost(hours, cost) {
  if (cost === null || cost === undefined || cost === "") return null;
  const value = Number(cost);
  if (!Number.isFinite(value) || value < 0 || (Number(hours) > 0 && value === 0)) {
    return null;
  }
  return value;
}
